import { render, staticRenderFns } from "./SvgHobbiesCategory.vue?vue&type=template&id=b86d1942&scoped=true"
import script from "./SvgHobbiesCategory.vue?vue&type=script&lang=js"
export * from "./SvgHobbiesCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgHobbiesCategory.vue?vue&type=style&index=0&id=b86d1942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86d1942",
  null
  
)

export default component.exports